


import screen1 from "./screen1.png";
import screen2 from "./screen2.png";
import screen3 from "./screen3.png";
import screen4 from "./screen4.png";
import screen5 from "./screen5.png";
import screen6 from "./screen6.png";
import screen7 from "./screen7.png";

const project_data = {
    tittle:"Colombia official chancellery page redesign",
    source:"https://github.com/juanda2222/cancilleria-colombia",
    website:"https://cancilleria-page-fsi7miwjuq-uc.a.run.app",
    abstract:"This is a full redesign of the official Colombian chancellery web page. The project includes the planning timeline, the designs and the result web page code with mocked data",
    hashtags:["react", "node", "npm", "aws", "typescript", "docker", "redux", "materialui"],
    prev_image_index: 0,
    images:[
        {
            caption:"Detail announcement", 
            image:screen1
        },
        {
            caption:"Detail announcement mobile", 
            image:screen2
        },
        {
            caption:"Menu mobile", 
            image:screen3
        },
        {
            caption:"Announcement list screen on mobile", 
            image:screen4
        },
        {
            caption:"Page home", 
            image:screen5
        },
        {
            caption:"Page search modal", 
            image:screen6
        },
        {
            caption:"News list screen", 
            image:screen7
        }
    ]
}

export default project_data
